import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import usersKeys from '../util/users-keys';
import {UserProps, translatedUserProps} from '../types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface EditUserProps extends UserProps {}

export const translatedEditUserProps: TranslatedKeys<EditUserProps> =
  translatedUserProps;

export interface EditUserAccessProps extends UserProps {}

export const translatedEditUserAccessProps: TranslatedKeys<EditUserAccessProps> =
  translatedUserProps;

const useEditUser = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: UserProps) => {
    update(usersKeys.list(), data);
    setData(usersKeys.details(id), data);
  };

  return useApiMutation<UserProps>({
    url: `/users/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar usuário',
    successTitle: 'Editar usuário',
    successMessage: 'Usuário atualizado com sucesso',
    onSuccess,
  });
};

export default useEditUser;
